<template>
  <div :class="$style.wrapper">
    <div :class="$style.image"><img src="@/images/ui/components/common/app-banner/app-image.jpg" alt="iichiの公式アプリ" width="281" height="270" loading="lazy" /></div>
    <p :class="$style.balloon">アプリ限定<br /><span>クーポン配布中！</span></p>
    <div :class="$style.content">
      <div :class="$style.text">
        <p :class="$style.title">iichiの公式アプリ</p>
        <p :class="$style.lead">いつでもどこでも、<br />お買い物がもっと便利に。</p>
      </div>
      <div :class="$style.link">
        <div :class="$style.qr"><img src="@/images/ui/components/common/app-banner/qr-code.png" alt="QRコード" width="74" height="74" loading="lazy" /></div>
        <ul :class="$style.download">
          <li>
            <a href="https://apps.apple.com/jp/app/id6639590827?mt=8" target="_blank"><img src="@/images/ui/components/common/app-banner/banner-appstore.png" alt="App Store からダウンロード" width="84" height="31" loading="lazy" /></a>
          </li>
          <li>
            <a href="https://play.google.com/store/apps/details?id=li.yapp.appFB584294&hl=ja" target="_blank"
              ><img src="@/images/ui/components/common/app-banner/banner-googleplay.png" alt="Google Play で手に入れよう" width="104" height="31" loading="lazy"
            /></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.wrapper {
  display: flex;
  font-family: var(--font-yu-gothic);
  justify-content: space-between;
  position: relative;

  @media (--sp) {
    flex-direction: column;
  }

  .image {
    @media (--sp) {
      img {
        aspect-ratio: 375 / 240;
        height: 100%;
        object-fit: cover;
        object-position: 0 -26px;
        width: 100%;
      }
    }
  }

  .balloon {
    align-items: center;
    background-color: var(--color-beige-alpha80);
    border-radius: 98px;
    color: var(--color-white);
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: bold;
    height: 196px;
    justify-content: center;
    left: 230px;
    position: absolute;
    text-align: center;
    top: 37px;
    width: 196px;

    @media (--sp) {
      font-size: 14px;
      height: 136px;
      left: auto;
      margin-bottom: 0;
      right: 2px;
      top: 40px;
      width: 136px;

      span {
        font-size: 16px;
      }
    }
  }

  .content {
    display: flex;
    flex-grow: 1;

    @media (--sp) {
      align-items: flex-end;
      padding: 20px 14px;
    }

    @media (--sp-mini) {
      padding-inline: 0;
    }
  }

  .text {
    flex-grow: 1;
    padding: 46px 0 0 148px;

    @media (--sp) {
      padding: 0;
    }
  }

  .title {
    font-size: 41px;
    font-weight: bold;
    letter-spacing: 2px;
    margin-bottom: 12px;

    @media (--sp) {
      font-size: min(6.2vw, 26px);
      margin-bottom: 8px;
    }
  }

  .lead {
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 2px;
    line-height: 1.8;
    margin-bottom: 0;

    @media (--sp) {
      font-size: min(4.3vw, 18px);
    }
  }

  .link {
    padding: 54px 36px 0 0;

    @media (--sp) {
      padding: 0 0 4px;
    }

    .qr {
      margin-bottom: 14px;

      @media (--sp) {
        display: none;
      }
    }

    .download {
      display: flex;
      flex-direction: column;
      gap: 7px;
    }
  }
}
</style>
